module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAAsUlEQVRIx2M4J6j2n1T8dYvEsT8Xxf7TAzOMOnDUgaMOJNOBhwVUBrcDfdn4/p8ZbA4EOeiEgOr/I8DQ42Zk+j+VRwbMPymoOjgcuJ1f6b8BC+d/ZgbG/wwMDGAswcTyv5dHanBFsQYzO9hxTEC8X0AZQ16+0+UYwzzP/3TB6JafBWJxYKjFcQj+FwXSk3mkB5cDtwGjeSGvHJh9HJj+Jg42BxKDRx046sBRB446kHgMAEh0BEwycyyAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/gw.png
// module id = 832
// module chunks = 0